export const FILE_UPLOAD_STATUS = {
  UPLOADING: 'uploading',
  DONE: 'done',
  ERROR: 'error',
  REMOVED: 'removed'
};
export const FILE_UPLOAD_BUTTON_TXT = 'Click to Upload';
export const FILE_MODAL_SEC_BUTTON_TXT = 'Close';
export const MODAL_TITLE = 'Add Attachments';